export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/pdp_image-f4abb841da5201cf5102460b7d4a6f2e.png";